export default {"src":"/_next/static/media/mock_dummy_call.e9b4e5f7.svg","height":54,"width":324,"blurWidth":0,"blurHeight":0};